namespace TabAurous.ECommerce {
    export interface ShippingForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        PartyId: Serenity.IntegerEditor;
        FreightId: Serenity.LookupEditor;
        PickupDate: Serenity.DateEditor;
        PickupTime: Serenity.TimeEditor;
        LabelId: Serenity.StringEditor;
        AWBNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: ShippingItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        ReceiptAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class ShippingForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.Shipping';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingForm.init)  {
                ShippingForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.LookupEditor;
                var w5 = s.TimeEditor;
                var w6 = s.DecimalEditor;
                var w7 = ShippingItemsEditor;
                var w8 = s.TextAreaEditor;

                Q.initFormType(ShippingForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'POSCustomerId', w3,
                    'PartyId', w2,
                    'FreightId', w4,
                    'PickupDate', w0,
                    'PickupTime', w5,
                    'LabelId', w1,
                    'AWBNumber', w1,
                    'CustomerName', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w4,
                    'ExchRate', w6,
                    'UserId', w4,
                    'EmployeeId', w2,
                    'ItemDetails', w7,
                    'FinancialYearId', w2,
                    'Pieces', w2,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'ReceiptAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'Remark', w8,
                    'ShipAddressId', w2,
                    'CompanyId', w2,
                    'ShipmentId', w2
                ]);
            }
        }
    }
}
